import React from 'react'

export const OrdersConsole = () => {
    return (
        <div>
            Mis ordenes
        </div>
    )
}
